import React, { Suspense } from 'react';

export default function LazySection({ children, label = 'กำลังโหลด...' }) {
  return (
    <Suspense
      fallback={
        <div className="status-message status-loading lazy-section" role="status" aria-live="polite">
          {label}
        </div>
      }
    >
      {children}
    </Suspense>
  );
}
